// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dropdown-menu-right {
  width: 330px;
  left: 0;
  z-index: 1000;
  float: right;
  position: absolute;
}

.app-notif-tile {
  padding-left: 20px;
  width: 100;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
